import React from 'react'
import { Avatar, Dropdown, Typography, Menu } from 'antd'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { AltArrowDownIcon } from "@solar-icons/react/outline/alt-arrow-down";
import { logout } from '../../redux/reducer/auth';
import CFG from '../../config/env';
const { BaseColor } = CFG;

export const UserProfile = ({ username, level, isColapsed }) => {
    const dispatch = useDispatch();

    const OverlayMenu = () => {
        return <Menu items={[
            {
                label: <Link to={'/profile'}>Profile</Link>,
                key: 'Profile'
            },
            {
                label: <a onClick={() => dispatch(logout())} style={{ cursor: 'pointer' }}>Logout</a>,
                key: 'Logout'
            },
        ]} />
    }
    const initial = ((username || 'A') + '').trim().charAt(0).toUpperCase();
    return (
        <div className={`user-profile-wrapper ${isColapsed ? 'user-profile-wrapper--compact' : ''}`}>
            <Dropdown placement='bottomRight' overlay={OverlayMenu} trigger={['click']}>
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
                    <Avatar size={36} style={{ backgroundColor: BaseColor || '#158550', fontSize: 14, fontWeight: 500 }}>{initial}</Avatar>
                    <span className='user-profile-text-wrapper'>
                        <Typography.Text strong className='user-profile-text'>
                            {username}
                        </Typography.Text>
                    </span>
                    <AltArrowDownIcon className='user-profile-chevron' />
                </span>
            </Dropdown>
        </div>
    )
}
